"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
const core_1 = require("@okxconnect/core");
const utils_1 = require("../utils");
const JsonRpcConnection_1 = require("./rpc/JsonRpcConnection");
const JsonRpcProvider_1 = require("./rpc/JsonRpcProvider");
class TONProvider {
    constructor(opts, client, events) {
        this.name = core_1.NameSpaceKeyTON;
        this.namespace = opts.namespace;
        this.events = events;
        this.client = client;
        this.chainId = this.getDefaultChain();
        this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(namespace) {
        this.namespace = Object.assign(this.namespace, namespace);
    }
    isRecord(value) {
        return typeof value === "object" && value !== null && !Array.isArray(value);
    }
    request(args) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            (0, core_1.logDebug)("TONProvider request --args--string>", JSON.stringify(args));
            (0, core_1.logDebug)("TONProvider request provider namespace: ", this.namespace);
            if (!this.client.needCheckRequestMethod() || this.namespace.methods.includes(args.method)) {
                if (!args.params) {
                    throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, "ton request params is nil");
                }
                if (this.isRecord(args.params)) {
                    const _e = args.params, { validUntil } = _e, newParams = __rest(_e, ["validUntil"]);
                    let fromAddress = (_b = (_a = this.namespace.payload) === null || _a === void 0 ? void 0 : _a.ton_addr) === null || _b === void 0 ? void 0 : _b.address;
                    if ('from' in newParams) {
                        fromAddress = newParams.from || ((_d = (_c = this.namespace.payload) === null || _c === void 0 ? void 0 : _c.ton_addr) === null || _d === void 0 ? void 0 : _d.address);
                    }
                    args.params['from'] = fromAddress;
                    args.params['network'] = this.getDefaultChain();
                    args.params['valid_until'] = validUntil;
                    let response = yield this.client.request(args);
                    if (this.isRecord(response) && 'result' in response) {
                        const result = {
                            boc: response.result.toString()
                        };
                        (0, core_1.logDebug)("TONProvider request provider response: ", JSON.stringify(response));
                        (0, core_1.logDebug)("TONProvider request provider result: ", JSON.stringify(result));
                        return result;
                    }
                    throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, "ton_send request response is nil");
                }
                else {
                    throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, "ton request params type add nil");
                }
            }
            return this.getHttpProvider().request(args);
        });
    }
    requestAccounts() {
        return this.getAccounts();
    }
    setDefaultChain(chainId, rpcUrl) {
        if (!this.httpProviders[chainId]) {
            this.setHttpProvider(chainId, rpcUrl);
        }
        this.chainId = chainId;
        this.events.emit(constants_1.PROVIDER_EVENTS.DEFAULT_CHAIN_CHANGED, `${this.name}:${chainId}`);
    }
    getDefaultChain() {
        if (this.chainId)
            return this.chainId;
        if (this.namespace.defaultChain)
            return this.namespace.defaultChain;
        const chainId = this.namespace.chains[0];
        if (!chainId)
            throw new Error(`ChainId not found`);
        return chainId.split(":")[1];
    }
    // --------- PRIVATE --------- //
    getAccounts() {
        var _a, _b;
        const accounts = this.namespace.accounts;
        (0, core_1.logDebug)("ton getAccounts accounts :", accounts);
        (0, core_1.logDebug)("ton getAccounts .namespace :", JSON.stringify(this.namespace));
        if (!accounts) {
            return [];
        }
        let address = (_b = (_a = this.namespace.payload) === null || _a === void 0 ? void 0 : _a.ton_addr) === null || _b === void 0 ? void 0 : _b.address;
        (0, core_1.logDebug)("ton getAccounts address :", address);
        if (address) {
            return [
                address
            ];
        }
        return [];
    }
    createHttpProviders() {
        const http = {};
        this.namespace.chains.forEach((chain) => {
            const parsedChainId = (0, utils_1.getChainId)(chain);
            const parsedRpc = (0, utils_1.getRpcUrl)(chain, this.namespace);
            let httpProvider = this.createHttpProvider(parsedChainId, parsedRpc);
            if (httpProvider) {
                http[parsedChainId] = httpProvider;
            }
        });
        return http;
    }
    getHttpProvider() {
        const chain = `${this.chainId}`;
        const http = this.httpProviders[chain];
        (0, core_1.logDebug)('[RPC] get http provider:', chain, http);
        if (typeof http === "undefined") {
            throw new Error(`JSON-RPC provider for ${chain} not found`);
        }
        return http;
    }
    setHttpProvider(chainId, rpcUrl) {
        const http = this.createHttpProvider(chainId, rpcUrl);
        if (http) {
            (0, core_1.logDebug)("setHttpProvider", chainId, rpcUrl);
            this.httpProviders[chainId] = http;
        }
    }
    createHttpProvider(chainId, rpcUrl) {
        // 没有备用rpc对外提供
        const rpc = rpcUrl;
        if (!rpc) {
            (0, core_1.logDebug)(`No RPC url provided for chainId: ${chainId}`);
            // throw new Error(`No RPC url provided for chainId: ${chainId}`);
        }
        else {
            const http = new JsonRpcProvider_1.JsonRpcProvider(new JsonRpcConnection_1.JsonRpcConnection(rpc, (0, utils_1.getGlobal)("disableProviderPing")));
            return http;
        }
    }
    showRequestModal(args) {
        switch (args.method) {
            case "ton_sendTransaction":
                return true;
            default:
                return false;
        }
        return false;
    }
}
exports.default = TONProvider;
